import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react';
import { useNavigate } from 'react-router-dom';
import { AuthAlert } from '../AuthAlert'; // Import the alert component
import { API_URL } from '../../utils/constants';
import auth from '../../Auth';
import Breadcrumbs from '../Breadcrumbs';
import axios from 'axios';
import { toast } from 'react-toastify';
import { TOAST_STYLE_SUCCESS } from '../../utils/constants';
import { Play, X, Loader2 } from 'lucide-react';

const PropmtsTable = ({ page }) => {
  const [prompts, setPrompts] = useState([]);
  const [showAlert, setShowAlert] = useState(false); // State to control the alert visibility
  const navigate = useNavigate(); // Hook to programmatically navigate

  function fetchPrompts() {
    const token = auth.syncGetIdToken();
    fetch(`${API_URL}/prompts`, {
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data.length) {
          navigate('/start');
        }
        setPrompts(data);
      })
      .catch((error) => console.error('Error fetching prompts:', error));
  }

  useEffect(() => {
    fetchPrompts();
  }, []);

  const handleRowClick = (id) => {
    navigate(`/${page}/${id}`);
  };

  const [delPromptId, setDelPromptId] = useState(-1);
  const [isDeleting, setIsDeleting] = useState(false);

  const createNew = () => {
    navigate('/prompt/new');
  };

  const crumbs = [
    { path: '/', breadcrumb: 'Home' },
    { path: window.location.href, breadcrumb: 'Prompts' }
  ];

  const handleDeletePrompt = async (prompt_id, id) => {
    setIsDeleting(true);
    setDelPromptId(id);
    await axios
      .delete(`${API_URL}/prompts/${prompt_id}`, {
        headers: {
          Authorization: `Bearer ${await auth.getIdToken()}`,
          'Content-Type': 'application/json'
        }
      })
      .then(() => {
        toast.success(`Prompt was deleted!`, TOAST_STYLE_SUCCESS);
        fetchPrompts();
      })
      .catch((err) => console.log(err));
    setIsDeleting(false);
    setDelPromptId(-1);
  };

  function formatDateTime(input) {
    const date = new Date(input);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${hours}:${minutes}:${seconds} ${day}.${month}.${year}`;
  }

  return (
    <div className='flex flex-col w-full p-8 space-y-8'>
      <Breadcrumbs crumbs={crumbs} />
      <div className='col-span-2 grid grid-cols-1 gap-4'>
        <h1 className='col-span-4 text-2xl font-bold'>Choose Prompt:</h1>
      </div>
      {showAlert && <AuthAlert />}
      <Table className='max-h-[65vh]' isHeaderSticky aria-label='Prompt Library Table'>
        <TableHeader>
          <TableColumn>Prompt Id</TableColumn>
          <TableColumn>Latest version</TableColumn>
          <TableColumn>
            <button
              onClick={createNew}
              style={{ backgroundColor: '#000000', padding: '0.5rem 0.7rem', borderRadius: '0.4rem', color: 'white' }}
            >
              Create New Prompt
            </button>
          </TableColumn>
        </TableHeader>
        <TableBody>
          {prompts.map((prompt, index) => (
            <TableRow key={prompt.prompt_id}>
              <TableCell onClick={() => handleRowClick(prompt.prompt_id)} className='hover:bg-gray-100 cursor-pointer'>
                {prompt.prompt_id}
              </TableCell>
              <TableCell>
                  {prompt?.version && prompt.version.length > 5 ? formatDateTime(prompt.version) : prompt.version}
              </TableCell>
              <TableCell>
                <div className='flex gap-2 items-center ml-8'>
                  <Play cursor={'pointer'} onClick={() => window.open(`/playground/${prompt.prompt_id}`)} color='black' size={25} />
                  {isDeleting && delPromptId === index ? (
                    <Loader2 size={25} color='black' className='animate-spin' />
                  ) : (
                    <X color='black' size={25} cursor={'pointer'} onClick={() => handleDeletePrompt(prompt.prompt_id, index)} />
                  )}
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default PropmtsTable;
